import {
  BroadbandProductDetails,
  BroadbandQuoteRequirements,
  CallingFeatures,
  ChargeAmount,
  Product,
  ProductType,
  Quote,
  QuoteRequirement,
} from '@generated/gql/graphql';
import { IOTSData } from '@src/types/oneTouchSwitching';

import { BooleanSelection } from './index';

enum CallPackages {
  offPeakSaver = 'offPeakSaver',
  peakSaver = 'peakSaver',
}

interface BroadbandFormValues {
  wifiUpgrade: boolean;
  landline: string;
  callPackage: BooleanSelection;
  callPackageId: Nullable<keyof CallingFeatures>;
  selectedTariff: string;
  includeVoip: Nullable<BooleanSelection>;
  isOTS?: boolean;
}

interface BroadbandProduct extends Product {
  details: BroadbandProductDetails;
}

interface BroadbandRequirement extends QuoteRequirement {
  requirement: BroadbandQuoteRequirements;
}

interface BroadbandQuote extends Quote {
  id: ProductType.Broadband;
  product: BroadbandProduct;
  requirements: BroadbandRequirement[];
}

type BroadbandSwitchState = Omit<
  IOTSData,
  'currentAddress' | 'orderType' | 'numberToPort' | 'surname' | 'canSubmit'
>;

interface BroadbandBasketData {
  available: boolean;
  yourService: Nullable<BroadbandFormValues>;
  quotes: BroadbandQuote[];
  monthlyCost: ChargeAmount;
  tbybEligible: boolean; // ignores service count check
  tbybActive: boolean; // fully qualified for discount
}

export { CallPackages };
export type {
  BroadbandFormValues,
  BroadbandProduct,
  BroadbandQuote,
  BroadbandBasketData,
  BroadbandSwitchState,
};
